import { useCallback } from "react";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { Stack } from "@fluentui/react/lib/Stack";

import { IKeyValue } from "Components/Generic/KeyValueGrid/IKeyValue";
import { ItemKeyValueGrid } from "Components/Generic/KeyValueGrid/ItemKeyValueGrid";
import { Value } from "Components/Generic/KeyValueGrid/Value";
import { WithTheme } from "Components/Generic/Theme/WithTheme";
import { WithTranslator } from "Components/Generic/Translator";
import { getItemType } from "Utils/Item";
import { DC_RESULT_COLUMN_LIST } from "../DuplicateCheckColums";
import { WithMergeContext } from "../MergeContext/WithMergeContext";
import { IValidateContentProps } from "./IValidateContentProps";
import { useValidateContentStyles } from "./UseValidateContentStyles";

export const ValidateContent = WithTheme(
  WithMergeContext(
    WithTranslator((props: IValidateContentProps): JSX.Element => {
      const {
        mergedProjectItem,
        onPrevious,
        onMergeSave,
        translator,
        theme: { spacing }
      } = props;
      const { styles, gridStyles } = useValidateContentStyles();
      const onMergeSaveInt = useCallback(() => {
        onMergeSave(mergedProjectItem[`@id`]);
      }, [mergedProjectItem, onMergeSave]);

      const items = DC_RESULT_COLUMN_LIST.map<IKeyValue>((column) => ({
        key: column,
        value: <Value fieldName={column} item={mergedProjectItem} placeholder="-" />
      }));

      return (
        <Stack tokens={{ childrenGap: spacing.m }} className={styles.root}>
          <Stack.Item className={styles.grid}>
            <ItemKeyValueGrid
              entityType={getItemType(mergedProjectItem)}
              header="&nbsp;"
              items={items}
              styleSet={gridStyles}
            />
          </Stack.Item>
          <Stack horizontal horizontalAlign="end" tokens={{ childrenGap: spacing.s1 }}>
            <DefaultButton onClick={onPrevious} iconProps={{ iconName: `ChevronLeft` }}>
              {translator.get(`generic.previous`, `Previous`)}
            </DefaultButton>
            <PrimaryButton onClick={onMergeSaveInt}>{translator.get(`generic.accept`, `Accept`)}</PrimaryButton>
          </Stack>
        </Stack>
      );
    })
  )
);
